import Modal from '../../components/Modal';
import AlertAccent from '../../components/AlertAccent';
import * as React from 'react';
import { resetPassRqApi } from '../../api/api';
import { toast } from 'react-toastify';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledInput from '../../components/ControlledInput';
import { COMMON_FORM_ERRORS } from '../../constants';
import { ControlledCheckbox } from '../../components/Checkbox';
import { ROLES } from '../../hooks/use-role';

const ResetPassword = ({ showAddModal, setShowAddModal }) => {
  const [resErr, setResErr] = React.useState([]);
  const [resOk, setResOk] = React.useState(false);
  const methods = useForm({ mode: 'onTouched' });

  const handleSubmit = async (data) => {
    const { isEngineer, ...rest } = data;
    const formData = { ...rest, ...(isEngineer && { role: ROLES.ENGINEER }), redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'resetpass' };

    setResErr([]);
    await resetPassRqApi(
      formData,
      function () {
        setResOk(true);
      },
      function (err) {
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
        setResErr((p) => [...p, err.error ? err : { error: 'Ошибка сервера' }]);
      }
    );
  };

  const close = async () => {
    setResErr([]);
    setResOk(false);
    methods.reset();
    toast.dismiss();
  };

  return (
    <Modal
      showModal={showAddModal}
      setShowModal={setShowAddModal}
      titleOn="Сбросить"
      saveCb={methods.handleSubmit(handleSubmit)}
      showSave={!resOk}
      closeCb={close}
      title="Сброс пароля"
      error={resErr}>
      <FormProvider {...methods}>
        <form className={'mb-2'}>
          <ControlledInput
            label="Для сброса пароля введите ваш Email"
            name={'email'}
            placeholder={'someone@example.com'}
            rules={{
              required: {
                value: true,
                message: COMMON_FORM_ERRORS.REQUIRED,
              },
            }}
          />
          <ControlledCheckbox
            labelClassName={'text-gray-700'}
            control={methods.control}
            name={'isEngineer'}
            label={'Не компания? Восстановить доступ как инженер'}
          />
        </form>
      </FormProvider>
      {resOk && <AlertAccent title="" text="На вашу почту была отправлена ссылка. Для сброса пароля перейдите по ней" showAlert={true}></AlertAccent>}
    </Modal>
  );
};

export default ResetPassword;
